import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { GUEST_USER_ID } from '@services/user.service';
import { filter, map } from 'rxjs';
import { SessionStoreSelectors } from 'src/app/root-store';

@Component({
    selector: 'app-header-buttons',
    templateUrl: './header-buttons.component.html',
    styleUrls: ['./header-buttons.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderButtonsComponent {
    private store = inject(Store);

    isLoggedIn$ = this.store.select(SessionStoreSelectors.getUserId).pipe(
        filter(userId => userId !== GUEST_USER_ID),
        map(userId => !!userId)
    );
}
